import request from './request'

export const UserInfoApi = params => request.get('api/user/info', {
  params
})

// http://gkb.gaozhaotong.cn/api/user/wxlogin?zjl=1  Appid: "wxb5a883c5bf26e000" Code: "081mps0w3W9IWY2M9y0w3NFlK50mps0b"
// From: "AnAsAH1"
export const UserLoginApi = params => request.post('/api/user/wxlogin', params)



// WEBPACK FOOTER //
// ./src/request/api.js